import React from 'react';

import { ChartOfAccountsAccount } from '@futrli-sdk/predict';

import { MultiPaymentTreatment, PaymentTreatment } from '../../types';
import { MultiPaymentDays } from './components/multi-payment-days/multi-payment-days';
import { NonCashTransfer } from './components/non-cash-transfer/non-cash-transfer';
import { PaymentTreatmentInput } from './components/payment-treatment-input/payment-treatment-input';
import { SinglePayment } from './components/single-payment/single-payment';

export interface CashFlowImpactProps {
  paymentTreatment: PaymentTreatment | null;
  handlePaymentTreatmentChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePaymentTermsChange: (value: string) => void;
  paymentTerms: string;
  multiPaymentData: MultiPaymentTreatment[];
  handleChangeMultiPaymentTreatmentData: (index: number, data: MultiPaymentTreatment) => void;
  addNewMultiPaymentTreatment: () => void;
  accountRows: ChartOfAccountsAccount[];
  nonCashAccountIndex: string;
  handleAutocompleteChange: (value: ChartOfAccountsAccount | null) => void;
  predictionContentTouched: boolean;
}

export const CashFlowImpact = ({
  paymentTreatment,
  handlePaymentTreatmentChange,
  multiPaymentData,
  handleChangeMultiPaymentTreatmentData,
  addNewMultiPaymentTreatment,
  handlePaymentTermsChange,
  paymentTerms,
  accountRows,
  nonCashAccountIndex,
  handleAutocompleteChange,
  predictionContentTouched
}: CashFlowImpactProps) => {
  const handleDaysChange = (index: number, value: string) => {
    handleChangeMultiPaymentTreatmentData(index, {
      ...multiPaymentData[index],
      payment_terms: value
    });
  };

  const handlePercentageChange = (index: number, value: string) => {
    handleChangeMultiPaymentTreatmentData(index, {
      ...multiPaymentData[index],
      payment_percentage: value
    });
  };

  return (
    <div>
      <PaymentTreatmentInput onChange={handlePaymentTreatmentChange} paymentTreatment={paymentTreatment} />

      {paymentTreatment === PaymentTreatment.SINGLE && (
        <SinglePayment onPaymentTermsChange={handlePaymentTermsChange} paymentTerms={paymentTerms} />
      )}
      {paymentTreatment === PaymentTreatment.MULTI_PAYMENT_DAYS && (
        <MultiPaymentDays
          onAddNew={addNewMultiPaymentTreatment}
          onDaysChange={handleDaysChange}
          onPercentageChange={handlePercentageChange}
          multiPaymentData={multiPaymentData}
        />
      )}
      {paymentTreatment === PaymentTreatment.NON_CASH_TRANSFER && (
        <NonCashTransfer
          accountRows={accountRows}
          nonCashAccountIndex={nonCashAccountIndex}
          onChange={handleAutocompleteChange}
          predictionContentTouched={predictionContentTouched}
        />
      )}
    </div>
  );
};
